import * as React from 'react'
import StudentTeacherDashboardResponsiveDrawer from './StudentTeacherDashboardResponsiveDrawer'
import { ISchool } from '../../../interfaces/school.interface'
import { IUserType } from '../../../interfaces/user.interface'

interface ISchoolUserDetailsContainer {
  children?: any
  schoolDetails: ISchool
  userId: string
  userType: IUserType
  customContentStyle?: any
}
const StudentTeacherDashboardContainer: React.FunctionComponent<ISchoolUserDetailsContainer> = (
  props: ISchoolUserDetailsContainer,
) => {
  return (
    <StudentTeacherDashboardResponsiveDrawer
      userType={props.userType}
      userId={props.userId}
      schoolDetails={props.schoolDetails}
      customContentStyle={props.customContentStyle}
    >
      {props.children}
    </StudentTeacherDashboardResponsiveDrawer>
  )
}

export default StudentTeacherDashboardContainer
